import { ReactNode } from 'react';
import { withStyles } from 'vopay';
import { BodyText, Card, Title } from 'UI';
import styles from './DetailsModule.module.scss';

const cn = withStyles(styles);

type DetailsModuleProps = {
  title: string;
  /**
   * The two Figma scales a details tab is drawn at: `sm` is the account page (Body/13/Medium title),
   * `rg` the partner page (H4/Large Title 20/Emphasized title). The rows inside follow the same size.
   */
  size: 'sm' | 'rg';
  /** The section already carries its title as its accessible name, which is how a test finds it. */
  'data-testid'?: string;
  children: ReactNode;
};

/** Figma "Module" (spec 5.6.1): a title over a card of detail rows. */
export default function DetailsModule({ title, size, 'data-testid': testId, children }: DetailsModuleProps) {
  return (
    <section className={cn('module')} aria-label={title} data-testid={testId}>
      {size === 'sm' ? (
        <BodyText size="sm" weight="md">
          {title}
        </BodyText>
      ) : (
        <Title level="4" className={cn('title')}>
          {title}
        </Title>
      )}

      <Card variant="section" className={cn('card')}>
        {children}
      </Card>
    </section>
  );
}
